const Alert = require('./alert');

class Payment {
    constructor () {
        this.template = require('./template.hbs');
    }

    render () {
        return this.$context.getWatcherData();
    }
}

module.exports = {
    constructor: Payment,
    children: [
        {
            name: 'alert',
            component: Alert,
            watcher: {
                alertType: ['payment', 'alertType'],
                redirectLink: ['payment', 'redirectLink']
            }
        }
    ]
};



// WEBPACK FOOTER //
// ./components/payment/index.js